import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const productsJsmGlobalOpsReportsRedirectRoute: InvariantJiraRoute = {
	name: 'products-jsm-global-ops-reports',
	path: '/jira/settings/products/ops/reports',
	exact: true,
};
